import React, { Component } from 'react'
import Toolbar from 'material-ui/Toolbar'
import ExpandableSearch from '../ExpandableSearch'
import Paper from 'material-ui/Paper'
import SortIcon from 'material-ui-icons/Sort'
// import Menu, { MenuItem } from 'material-ui/Menu'
import { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'

type Props = {
  onChange: Function
}

const options = [
  'best attendance',
  'worst attendance',
]

class SearchBar extends Component<Props> {
  state = {
    anchorEl: null,
    selectedIndex: 0,
  }

  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  render () {
    const { onChange } = this.props

    // const { anchorEl } = this.state;

    return (
      <Paper elevation={1}>
        <Toolbar disableGutters>
          <ListItem
            button
            onClick={this.handleClickListItem}
          >
            <ListItemIcon>
              <SortIcon />
            </ListItemIcon>
            <ListItemText
              primary={options[this.state.selectedIndex]}
            />
          </ListItem>

          {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {options.map((option, index) => (
              <MenuItem
                key={option}
                selected={index === this.state.selectedIndex}
                onClick={event => this.handleMenuItemClick(event, index)}
              >
                {option}
              </MenuItem>
            ))}
          </Menu> */}

          <ExpandableSearch
            placeholder='Search by Name or Ward'
            onChangeValue={onChange}
          />
        </Toolbar>
      </Paper>
    )
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js